import { useQuery } from 'react-query'

import { useSpotify } from '../useSpotify'

export function useQuerySpotifyProfile() {
  const { auth, profileService } = useSpotify()

  const { fn, key } = profileService.queries.profile

  return useQuery(key, fn, {
    // 24 hours
    cacheTime: 1000 * 60 * 60 * 24 * 7,

    enabled: auth.isAuthenticated,
    staleTime: 1000 * 60 * 60 * 24 // 7 days
  })
}
